"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.takeWhileRecipe = void 0;
const recipes_1 = require("../recipes");
const types_internal_1 = require("../types-internal");
const prepare_1 = require("../types-internal/prepare");
function takeWhileRecipe(takeWhileIterable) {
    const base = (0, recipes_1.augmentIterableRecipe)(takeWhileIterable);
    return function (baseAction) {
        const action = (0, prepare_1.prepare)(baseAction);
        return (0, types_internal_1.keepOrderAssuring)(base.call(this, action), this);
    };
}
exports.takeWhileRecipe = takeWhileRecipe;
